import exampleJuiceFront from "./images/exampleJuiceFront.png";
import exampleJuiceSideLeft from "./images/exampleJuiceSideLeft.png";
import exampleWineBack from "./images/exampleWineBack.png";

const questions = [
  {
    id: 1,
    question:
      "Kann der Kunde einfach erkennen, um was für ein Produkt es sich handelt?",
    explanation: "",
    answered: false,
    active: true,
    clipArea: "170px, 160px, 210px, 10px",
    image: exampleJuiceFront,
  },
  {
    id: 2,
    question:
      "Dein Produkt zeichnet sich besonders aus. Sind alle Siegel korrekt angegeben?",
    explanation: "",
    answered: false,
    active: false,
    clipArea: "250px, 150px, 600px, 80px",
    image: exampleJuiceFront,
  },
  {
    id: 3,
    question:
      "Ist ein Zutatenverzeichnis vorhanden und sind alle Zutaten für den Vertrieb als Lebensmittel zugelassen?",
    explanation: "",
    answered: false,
    active: false,
    clipArea: "220px, 160px, 330px, 0px",
    image: exampleJuiceSideLeft,
  },
  {
    id: 5,
    question: "Ist das Gewicht bzw. Volumen angegeben?",
    explanation: "",
    answered: false,
    active: false,
    clipArea: "380px, 160px, 420px, 90px",
    image: exampleJuiceSideLeft,
  },
  {
    id: 6,
    question: "Ist eine deutsche Postanschrift auf dem Etikett vorhanden?",
    explanation: "",
    answered: false,
    active: false,
    clipArea: "380px, 110px, 420px, 10px",
    image: exampleJuiceSideLeft,
  },
  {
    id: 7,
    question:
      "Ist ein Barcode vorhanden und befindet sich die GTIN ausgeschrieben unter dem Barcode?",
    explanation: "",
    answered: false,
    active: false,
    clipArea: "400px, 150px, 600px, 10px",
    image: exampleJuiceSideLeft,
  },
  {
    id: 8,
    question:
      "Ist das Produkt bei der Verräumung und Regalplatzierung einfach zu handhaben?",
    explanation: "",
    answered: false,
    active: false,
    clipArea: "0px, 230px, 600px, 0px",
    image: exampleJuiceFront,
  },
  {
    id: 9,
    question: "Sind Angaben zum Promille-Gehalt vorhanden?",
    explanation: "",
    answered: false,
    active: false,
    clipArea: "400px, 160px, 600px, 60px",
    image: exampleWineBack,
  },
];
export default questions;
